import React from 'react';
import './Button.css';
function Button(props) {
  return (
    <button data-testid="otpverification" className={props.className ? props.className:'button'} onClick={props.onClick} disabled={props.disabled ? props.disabled : false}>{props.children}</button>
  )
}

export default Button